// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"e6fc3634","231":"404f6c71"}[chunkId] + ".chunk.js";
};